import React from 'react';
import Nav from '../Components/Nav';
import { Link } from 'react-router-dom';
import { 
    MDBContainer,
    MDBBreadcrumb,
    MDBBreadcrumbItem
 } from 'mdb-react-ui-kit';

export default function Error() {
    return(
        <MDBContainer fluid className="text-center text-black px-5 pt-5 backgroundImg">
            <Nav />
            <h1 className='pt-5'>ERROR: This Page Doesn't Exist Yet Bruv..</h1>
            <img src='assets/404.jpg' className="error" alt='ERROR 404: Page Does Not Exist'></img>

        </MDBContainer>

    );
}